import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useCallback, useMemo, useState } from 'react';
import { useDimensions } from '@noths/polaris-client-react-hooks';
import { IconUserMember, IconUserOutlined, IconUserSolid } from '@noths/polaris-client-ribbons-design-system';
import { IconBarItem, IconBarItemLabel } from "./IconBarItem";
import * as styles from "./IconBar.styles";
import { AccountPopover } from "../AccountPopover/AccountPopover";
import { useUserContext } from "../../../context/UserContext/useUserContext";
export var MyAccount = function MyAccount() {
  var _useUserContext = useUserContext(),
    membershipIsActive = _useUserContext.membershipIsActive,
    userAuthenticated = _useUserContext.userAuthenticated;
  var _useDimensions = useDimensions(),
    accountIconDimensions = _useDimensions.dimensions,
    accountIconRef = _useDimensions.ref;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isAccountPopoverOpen = _useState2[0],
    setAccountPopoverOpen = _useState2[1];
  var href = userAuthenticated ? '/user/orders' : '/u/sign-in';
  var position = useMemo(function () {
    return {
      x: accountIconDimensions.x + accountIconDimensions.width / 2,
      y: accountIconDimensions.bottom
    };
  }, [accountIconDimensions.x, accountIconDimensions.width, accountIconDimensions.bottom]);
  var onMyAccountClick = useCallback(function (e) {
    e.preventDefault();
    setAccountPopoverOpen(true);
  }, []);
  var onCloseHandler = useCallback(function () {
    return setAccountPopoverOpen(false);
  }, []);
  return /*#__PURE__*/React.createElement(IconBarItem, null, /*#__PURE__*/React.createElement(_StyledA, {
    href: href,
    onClick: onMyAccountClick,
    ref: isAccountPopoverOpen ? accountIconRef : null,
    $_css: [styles.link, isAccountPopoverOpen && styles.focusedLink]
  }, userAuthenticated && membershipIsActive ? /*#__PURE__*/React.createElement(_StyledIconUserMember, {
    $_css2: [styles.icon]
  }) : userAuthenticated ? /*#__PURE__*/React.createElement(_StyledIconUserSolid, {
    $_css3: styles.icon
  }) : /*#__PURE__*/React.createElement(_StyledIconUserOutlined, {
    $_css4: styles.icon
  }), /*#__PURE__*/React.createElement(IconBarItemLabel, null, "My Account")), /*#__PURE__*/React.createElement(AccountPopover, {
    isOpen: isAccountPopoverOpen,
    onClose: onCloseHandler,
    position: position
  }));
};
var _StyledA = _styled("a")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledIconUserMember = _styled2(IconUserMember)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledIconUserSolid = _styled3(IconUserSolid)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledIconUserOutlined = /*#__PURE__*/_styled4(IconUserOutlined).withConfig({
  displayName: "MyAccount___StyledIconUserOutlined",
  componentId: "sc-x7o6ry-0"
})(["", ""], function (p) {
  return p.$_css4;
});